import React from "react";

class ScrollButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      intervalId: 0,
      display: false
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  handleScroll(event) {
    if (window.scrollY > 350) {
      this.setState({ display: true });
    }else{
      this.setState({ display: false });
    }
  }

  scrollStep() {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  scrollToTop() {
    let intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({ intervalId: intervalId });
  }

  render() {
    return <button title="Back to top" className={this.state.display ? "btn-scroll" : "d-none"}
      onClick={() => { this.scrollToTop(); }}>
      <span className="icon ion-md-arrow-up"></span>
    </button>;
  }
}

export default ScrollButton;